import script from "./start.vue?vue&type=script&setup=true&lang=js"
export * from "./start.vue?vue&type=script&setup=true&lang=js"

import "./start.vue?vue&type=style&index=0&id=25ccaec7&lang=css"

const __exports__ = script;

export default __exports__